/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * NEXMAIL (Internal)
 * Internal API consumed by the nexmail dashboard.
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AudienceDto,
  CampaignDetailsResponseDto,
  CreateCampaignDto,
  CreateCampaignResponseDto,
  CreatedCampaignsResponseDto,
  EspExportControllerGetAudiencesParams,
  EspExportControllerGetCampaignDetailsParams,
  EspExportControllerGetCreatedCampaignsParams,
  EspStatusResponseDto,
  ExportTemplateDto,
  ExportTemplateResponseDto,
  ExportVariantGroupDto,
  ExportVariantGroupResponseDto,
  MergeTagsResponseDto,
  TemplateEspExportsResponseDto,
  UpdateCampaignDto,
} from '.././models';

import { authFetch } from '../../../../lib/api';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Get connected ESP status and capabilities
 */
export const espExportControllerGetStatus = (
  orgId: string,
  clientId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<EspStatusResponseDto>(
    { url: `/api/v1/organizations/${orgId}/clients/${clientId}/esp/status`, method: 'GET', signal },
    options
  );
};

export const getEspExportControllerGetStatusQueryKey = (orgId?: string, clientId?: string) => {
  return [`/api/v1/organizations/${orgId}/clients/${clientId}/esp/status`] as const;
};

export const getEspExportControllerGetStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof espExportControllerGetStatus>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof espExportControllerGetStatus>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getEspExportControllerGetStatusQueryKey(orgId, clientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof espExportControllerGetStatus>>> = ({
    signal,
  }) => espExportControllerGetStatus(orgId, clientId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(orgId && clientId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof espExportControllerGetStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EspExportControllerGetStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof espExportControllerGetStatus>>
>;
export type EspExportControllerGetStatusQueryError = unknown;

export function useEspExportControllerGetStatus<
  TData = Awaited<ReturnType<typeof espExportControllerGetStatus>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof espExportControllerGetStatus>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof espExportControllerGetStatus>>,
          TError,
          Awaited<ReturnType<typeof espExportControllerGetStatus>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEspExportControllerGetStatus<
  TData = Awaited<ReturnType<typeof espExportControllerGetStatus>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof espExportControllerGetStatus>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof espExportControllerGetStatus>>,
          TError,
          Awaited<ReturnType<typeof espExportControllerGetStatus>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEspExportControllerGetStatus<
  TData = Awaited<ReturnType<typeof espExportControllerGetStatus>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof espExportControllerGetStatus>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get connected ESP status and capabilities
 */

export function useEspExportControllerGetStatus<
  TData = Awaited<ReturnType<typeof espExportControllerGetStatus>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof espExportControllerGetStatus>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEspExportControllerGetStatusQueryOptions(orgId, clientId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get available audiences from the connected ESP
 */
export const espExportControllerGetAudiences = (
  orgId: string,
  clientId: string,
  params?: EspExportControllerGetAudiencesParams,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<AudienceDto[]>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/esp/audiences`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getEspExportControllerGetAudiencesQueryKey = (
  orgId?: string,
  clientId?: string,
  params?: EspExportControllerGetAudiencesParams
) => {
  return [
    `/api/v1/organizations/${orgId}/clients/${clientId}/esp/audiences`,
    ...(params ? [params] : []),
  ] as const;
};

export const getEspExportControllerGetAudiencesQueryOptions = <
  TData = Awaited<ReturnType<typeof espExportControllerGetAudiences>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params?: EspExportControllerGetAudiencesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof espExportControllerGetAudiences>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getEspExportControllerGetAudiencesQueryKey(orgId, clientId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof espExportControllerGetAudiences>>> = ({
    signal,
  }) => espExportControllerGetAudiences(orgId, clientId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(orgId && clientId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof espExportControllerGetAudiences>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EspExportControllerGetAudiencesQueryResult = NonNullable<
  Awaited<ReturnType<typeof espExportControllerGetAudiences>>
>;
export type EspExportControllerGetAudiencesQueryError = unknown;

export function useEspExportControllerGetAudiences<
  TData = Awaited<ReturnType<typeof espExportControllerGetAudiences>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params: undefined | EspExportControllerGetAudiencesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof espExportControllerGetAudiences>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof espExportControllerGetAudiences>>,
          TError,
          Awaited<ReturnType<typeof espExportControllerGetAudiences>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEspExportControllerGetAudiences<
  TData = Awaited<ReturnType<typeof espExportControllerGetAudiences>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params?: EspExportControllerGetAudiencesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof espExportControllerGetAudiences>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof espExportControllerGetAudiences>>,
          TError,
          Awaited<ReturnType<typeof espExportControllerGetAudiences>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEspExportControllerGetAudiences<
  TData = Awaited<ReturnType<typeof espExportControllerGetAudiences>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params?: EspExportControllerGetAudiencesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof espExportControllerGetAudiences>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get available audiences from the connected ESP
 */

export function useEspExportControllerGetAudiences<
  TData = Awaited<ReturnType<typeof espExportControllerGetAudiences>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params?: EspExportControllerGetAudiencesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof espExportControllerGetAudiences>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEspExportControllerGetAudiencesQueryOptions(
    orgId,
    clientId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Export a template to the connected ESP
 */
export const espExportControllerExportTemplate = (
  orgId: string,
  clientId: string,
  exportTemplateDto: ExportTemplateDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<ExportTemplateResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/esp/export-template`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: exportTemplateDto,
      signal,
    },
    options
  );
};

export const getEspExportControllerExportTemplateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof espExportControllerExportTemplate>>,
    TError,
    { orgId: string; clientId: string; data: ExportTemplateDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof espExportControllerExportTemplate>>,
  TError,
  { orgId: string; clientId: string; data: ExportTemplateDto },
  TContext
> => {
  const mutationKey = ['espExportControllerExportTemplate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof espExportControllerExportTemplate>>,
    { orgId: string; clientId: string; data: ExportTemplateDto }
  > = (props) => {
    const { orgId, clientId, data } = props ?? {};

    return espExportControllerExportTemplate(orgId, clientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EspExportControllerExportTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof espExportControllerExportTemplate>>
>;
export type EspExportControllerExportTemplateMutationBody = ExportTemplateDto;
export type EspExportControllerExportTemplateMutationError = unknown;

/**
 * @summary Export a template to the connected ESP
 */
export const useEspExportControllerExportTemplate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof espExportControllerExportTemplate>>,
      TError,
      { orgId: string; clientId: string; data: ExportTemplateDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof espExportControllerExportTemplate>>,
  TError,
  { orgId: string; clientId: string; data: ExportTemplateDto },
  TContext
> => {
  const mutationOptions = getEspExportControllerExportTemplateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Export selected variants of an A/B group to the connected ESP. v1 emits one template per variant; v2 will route to native A/B campaigns where supported.
 */
export const espExportControllerExportVariantGroup = (
  orgId: string,
  clientId: string,
  exportVariantGroupDto: ExportVariantGroupDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<ExportVariantGroupResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/esp/export-variant-group`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: exportVariantGroupDto,
      signal,
    },
    options
  );
};

export const getEspExportControllerExportVariantGroupMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof espExportControllerExportVariantGroup>>,
    TError,
    { orgId: string; clientId: string; data: ExportVariantGroupDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof espExportControllerExportVariantGroup>>,
  TError,
  { orgId: string; clientId: string; data: ExportVariantGroupDto },
  TContext
> => {
  const mutationKey = ['espExportControllerExportVariantGroup'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof espExportControllerExportVariantGroup>>,
    { orgId: string; clientId: string; data: ExportVariantGroupDto }
  > = (props) => {
    const { orgId, clientId, data } = props ?? {};

    return espExportControllerExportVariantGroup(orgId, clientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EspExportControllerExportVariantGroupMutationResult = NonNullable<
  Awaited<ReturnType<typeof espExportControllerExportVariantGroup>>
>;
export type EspExportControllerExportVariantGroupMutationBody = ExportVariantGroupDto;
export type EspExportControllerExportVariantGroupMutationError = unknown;

/**
 * @summary Export selected variants of an A/B group to the connected ESP. v1 emits one template per variant; v2 will route to native A/B campaigns where supported.
 */
export const useEspExportControllerExportVariantGroup = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof espExportControllerExportVariantGroup>>,
      TError,
      { orgId: string; clientId: string; data: ExportVariantGroupDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof espExportControllerExportVariantGroup>>,
  TError,
  { orgId: string; clientId: string; data: ExportVariantGroupDto },
  TContext
> => {
  const mutationOptions = getEspExportControllerExportVariantGroupMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Create a campaign in the connected ESP
 */
export const espExportControllerCreateCampaign = (
  orgId: string,
  clientId: string,
  createCampaignDto: CreateCampaignDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<CreateCampaignResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/esp/create-campaign`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createCampaignDto,
      signal,
    },
    options
  );
};

export const getEspExportControllerCreateCampaignMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof espExportControllerCreateCampaign>>,
    TError,
    { orgId: string; clientId: string; data: CreateCampaignDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof espExportControllerCreateCampaign>>,
  TError,
  { orgId: string; clientId: string; data: CreateCampaignDto },
  TContext
> => {
  const mutationKey = ['espExportControllerCreateCampaign'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof espExportControllerCreateCampaign>>,
    { orgId: string; clientId: string; data: CreateCampaignDto }
  > = (props) => {
    const { orgId, clientId, data } = props ?? {};

    return espExportControllerCreateCampaign(orgId, clientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EspExportControllerCreateCampaignMutationResult = NonNullable<
  Awaited<ReturnType<typeof espExportControllerCreateCampaign>>
>;
export type EspExportControllerCreateCampaignMutationBody = CreateCampaignDto;
export type EspExportControllerCreateCampaignMutationError = unknown;

/**
 * @summary Create a campaign in the connected ESP
 */
export const useEspExportControllerCreateCampaign = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof espExportControllerCreateCampaign>>,
      TError,
      { orgId: string; clientId: string; data: CreateCampaignDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof espExportControllerCreateCampaign>>,
  TError,
  { orgId: string; clientId: string; data: CreateCampaignDto },
  TContext
> => {
  const mutationOptions = getEspExportControllerCreateCampaignMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary List nexmail-created draft campaigns for a template or variant group, available for 'update existing' in the campaign dialog.
 */
export const espExportControllerGetCreatedCampaigns = (
  orgId: unknown,
  clientId: string,
  params?: EspExportControllerGetCreatedCampaignsParams,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<CreatedCampaignsResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/esp/created-campaigns`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getEspExportControllerGetCreatedCampaignsQueryKey = (
  orgId?: unknown,
  clientId?: string,
  params?: EspExportControllerGetCreatedCampaignsParams
) => {
  return [
    `/api/v1/organizations/${orgId}/clients/${clientId}/esp/created-campaigns`,
    ...(params ? [params] : []),
  ] as const;
};

export const getEspExportControllerGetCreatedCampaignsQueryOptions = <
  TData = Awaited<ReturnType<typeof espExportControllerGetCreatedCampaigns>>,
  TError = unknown,
>(
  orgId: unknown,
  clientId: string,
  params?: EspExportControllerGetCreatedCampaignsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof espExportControllerGetCreatedCampaigns>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getEspExportControllerGetCreatedCampaignsQueryKey(orgId, clientId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof espExportControllerGetCreatedCampaigns>>
  > = ({ signal }) =>
    espExportControllerGetCreatedCampaigns(orgId, clientId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(orgId && clientId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof espExportControllerGetCreatedCampaigns>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EspExportControllerGetCreatedCampaignsQueryResult = NonNullable<
  Awaited<ReturnType<typeof espExportControllerGetCreatedCampaigns>>
>;
export type EspExportControllerGetCreatedCampaignsQueryError = unknown;

export function useEspExportControllerGetCreatedCampaigns<
  TData = Awaited<ReturnType<typeof espExportControllerGetCreatedCampaigns>>,
  TError = unknown,
>(
  orgId: unknown,
  clientId: string,
  params: undefined | EspExportControllerGetCreatedCampaignsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof espExportControllerGetCreatedCampaigns>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof espExportControllerGetCreatedCampaigns>>,
          TError,
          Awaited<ReturnType<typeof espExportControllerGetCreatedCampaigns>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEspExportControllerGetCreatedCampaigns<
  TData = Awaited<ReturnType<typeof espExportControllerGetCreatedCampaigns>>,
  TError = unknown,
>(
  orgId: unknown,
  clientId: string,
  params?: EspExportControllerGetCreatedCampaignsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof espExportControllerGetCreatedCampaigns>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof espExportControllerGetCreatedCampaigns>>,
          TError,
          Awaited<ReturnType<typeof espExportControllerGetCreatedCampaigns>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEspExportControllerGetCreatedCampaigns<
  TData = Awaited<ReturnType<typeof espExportControllerGetCreatedCampaigns>>,
  TError = unknown,
>(
  orgId: unknown,
  clientId: string,
  params?: EspExportControllerGetCreatedCampaignsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof espExportControllerGetCreatedCampaigns>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List nexmail-created draft campaigns for a template or variant group, available for 'update existing' in the campaign dialog.
 */

export function useEspExportControllerGetCreatedCampaigns<
  TData = Awaited<ReturnType<typeof espExportControllerGetCreatedCampaigns>>,
  TError = unknown,
>(
  orgId: unknown,
  clientId: string,
  params?: EspExportControllerGetCreatedCampaignsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof espExportControllerGetCreatedCampaigns>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEspExportControllerGetCreatedCampaignsQueryOptions(
    orgId,
    clientId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List ESP templates a nexmail template has been exported to
 */
export const espExportControllerGetTemplateExports = (
  orgId: string,
  clientId: string,
  templateId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<TemplateEspExportsResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/esp/template-exports/${templateId}`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getEspExportControllerGetTemplateExportsQueryKey = (
  orgId?: string,
  clientId?: string,
  templateId?: string
) => {
  return [
    `/api/v1/organizations/${orgId}/clients/${clientId}/esp/template-exports/${templateId}`,
  ] as const;
};

export const getEspExportControllerGetTemplateExportsQueryOptions = <
  TData = Awaited<ReturnType<typeof espExportControllerGetTemplateExports>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof espExportControllerGetTemplateExports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getEspExportControllerGetTemplateExportsQueryKey(orgId, clientId, templateId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof espExportControllerGetTemplateExports>>
  > = ({ signal }) =>
    espExportControllerGetTemplateExports(orgId, clientId, templateId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(orgId && clientId && templateId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof espExportControllerGetTemplateExports>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EspExportControllerGetTemplateExportsQueryResult = NonNullable<
  Awaited<ReturnType<typeof espExportControllerGetTemplateExports>>
>;
export type EspExportControllerGetTemplateExportsQueryError = unknown;

export function useEspExportControllerGetTemplateExports<
  TData = Awaited<ReturnType<typeof espExportControllerGetTemplateExports>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  templateId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof espExportControllerGetTemplateExports>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof espExportControllerGetTemplateExports>>,
          TError,
          Awaited<ReturnType<typeof espExportControllerGetTemplateExports>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEspExportControllerGetTemplateExports<
  TData = Awaited<ReturnType<typeof espExportControllerGetTemplateExports>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof espExportControllerGetTemplateExports>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof espExportControllerGetTemplateExports>>,
          TError,
          Awaited<ReturnType<typeof espExportControllerGetTemplateExports>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEspExportControllerGetTemplateExports<
  TData = Awaited<ReturnType<typeof espExportControllerGetTemplateExports>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof espExportControllerGetTemplateExports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List ESP templates a nexmail template has been exported to
 */

export function useEspExportControllerGetTemplateExports<
  TData = Awaited<ReturnType<typeof espExportControllerGetTemplateExports>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof espExportControllerGetTemplateExports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEspExportControllerGetTemplateExportsQueryOptions(
    orgId,
    clientId,
    templateId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Fetch live state of a draft campaign from the ESP for prefill
 */
export const espExportControllerGetCampaignDetails = (
  orgId: string,
  clientId: string,
  espCampaignId: string,
  params: EspExportControllerGetCampaignDetailsParams,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<CampaignDetailsResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/esp/campaign-details/${espCampaignId}`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getEspExportControllerGetCampaignDetailsQueryKey = (
  orgId?: string,
  clientId?: string,
  espCampaignId?: string,
  params?: EspExportControllerGetCampaignDetailsParams
) => {
  return [
    `/api/v1/organizations/${orgId}/clients/${clientId}/esp/campaign-details/${espCampaignId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getEspExportControllerGetCampaignDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof espExportControllerGetCampaignDetails>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  espCampaignId: string,
  params: EspExportControllerGetCampaignDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof espExportControllerGetCampaignDetails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getEspExportControllerGetCampaignDetailsQueryKey(orgId, clientId, espCampaignId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof espExportControllerGetCampaignDetails>>
  > = ({ signal }) =>
    espExportControllerGetCampaignDetails(
      orgId,
      clientId,
      espCampaignId,
      params,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(orgId && clientId && espCampaignId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof espExportControllerGetCampaignDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EspExportControllerGetCampaignDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof espExportControllerGetCampaignDetails>>
>;
export type EspExportControllerGetCampaignDetailsQueryError = unknown;

export function useEspExportControllerGetCampaignDetails<
  TData = Awaited<ReturnType<typeof espExportControllerGetCampaignDetails>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  espCampaignId: string,
  params: EspExportControllerGetCampaignDetailsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof espExportControllerGetCampaignDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof espExportControllerGetCampaignDetails>>,
          TError,
          Awaited<ReturnType<typeof espExportControllerGetCampaignDetails>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEspExportControllerGetCampaignDetails<
  TData = Awaited<ReturnType<typeof espExportControllerGetCampaignDetails>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  espCampaignId: string,
  params: EspExportControllerGetCampaignDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof espExportControllerGetCampaignDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof espExportControllerGetCampaignDetails>>,
          TError,
          Awaited<ReturnType<typeof espExportControllerGetCampaignDetails>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEspExportControllerGetCampaignDetails<
  TData = Awaited<ReturnType<typeof espExportControllerGetCampaignDetails>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  espCampaignId: string,
  params: EspExportControllerGetCampaignDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof espExportControllerGetCampaignDetails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Fetch live state of a draft campaign from the ESP for prefill
 */

export function useEspExportControllerGetCampaignDetails<
  TData = Awaited<ReturnType<typeof espExportControllerGetCampaignDetails>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  espCampaignId: string,
  params: EspExportControllerGetCampaignDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof espExportControllerGetCampaignDetails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEspExportControllerGetCampaignDetailsQueryOptions(
    orgId,
    clientId,
    espCampaignId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update an existing draft campaign in the connected ESP
 */
export const espExportControllerUpdateCampaign = (
  orgId: string,
  clientId: string,
  updateCampaignDto: UpdateCampaignDto,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<CreateCampaignResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/esp/update-campaign`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateCampaignDto,
    },
    options
  );
};

export const getEspExportControllerUpdateCampaignMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof espExportControllerUpdateCampaign>>,
    TError,
    { orgId: string; clientId: string; data: UpdateCampaignDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof espExportControllerUpdateCampaign>>,
  TError,
  { orgId: string; clientId: string; data: UpdateCampaignDto },
  TContext
> => {
  const mutationKey = ['espExportControllerUpdateCampaign'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof espExportControllerUpdateCampaign>>,
    { orgId: string; clientId: string; data: UpdateCampaignDto }
  > = (props) => {
    const { orgId, clientId, data } = props ?? {};

    return espExportControllerUpdateCampaign(orgId, clientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EspExportControllerUpdateCampaignMutationResult = NonNullable<
  Awaited<ReturnType<typeof espExportControllerUpdateCampaign>>
>;
export type EspExportControllerUpdateCampaignMutationBody = UpdateCampaignDto;
export type EspExportControllerUpdateCampaignMutationError = unknown;

/**
 * @summary Update an existing draft campaign in the connected ESP
 */
export const useEspExportControllerUpdateCampaign = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof espExportControllerUpdateCampaign>>,
      TError,
      { orgId: string; clientId: string; data: UpdateCampaignDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof espExportControllerUpdateCampaign>>,
  TError,
  { orgId: string; clientId: string; data: UpdateCampaignDto },
  TContext
> => {
  const mutationOptions = getEspExportControllerUpdateCampaignMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get available ESP merge tags grouped by category
 */
export const espExportControllerGetMergeTags = (
  orgId: unknown,
  clientId: unknown,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<MergeTagsResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/esp/merge-tags`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getEspExportControllerGetMergeTagsQueryKey = (orgId?: unknown, clientId?: unknown) => {
  return [`/api/v1/organizations/${orgId}/clients/${clientId}/esp/merge-tags`] as const;
};

export const getEspExportControllerGetMergeTagsQueryOptions = <
  TData = Awaited<ReturnType<typeof espExportControllerGetMergeTags>>,
  TError = unknown,
>(
  orgId: unknown,
  clientId: unknown,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof espExportControllerGetMergeTags>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getEspExportControllerGetMergeTagsQueryKey(orgId, clientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof espExportControllerGetMergeTags>>> = ({
    signal,
  }) => espExportControllerGetMergeTags(orgId, clientId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(orgId && clientId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof espExportControllerGetMergeTags>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EspExportControllerGetMergeTagsQueryResult = NonNullable<
  Awaited<ReturnType<typeof espExportControllerGetMergeTags>>
>;
export type EspExportControllerGetMergeTagsQueryError = unknown;

export function useEspExportControllerGetMergeTags<
  TData = Awaited<ReturnType<typeof espExportControllerGetMergeTags>>,
  TError = unknown,
>(
  orgId: unknown,
  clientId: unknown,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof espExportControllerGetMergeTags>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof espExportControllerGetMergeTags>>,
          TError,
          Awaited<ReturnType<typeof espExportControllerGetMergeTags>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEspExportControllerGetMergeTags<
  TData = Awaited<ReturnType<typeof espExportControllerGetMergeTags>>,
  TError = unknown,
>(
  orgId: unknown,
  clientId: unknown,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof espExportControllerGetMergeTags>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof espExportControllerGetMergeTags>>,
          TError,
          Awaited<ReturnType<typeof espExportControllerGetMergeTags>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEspExportControllerGetMergeTags<
  TData = Awaited<ReturnType<typeof espExportControllerGetMergeTags>>,
  TError = unknown,
>(
  orgId: unknown,
  clientId: unknown,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof espExportControllerGetMergeTags>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get available ESP merge tags grouped by category
 */

export function useEspExportControllerGetMergeTags<
  TData = Awaited<ReturnType<typeof espExportControllerGetMergeTags>>,
  TError = unknown,
>(
  orgId: unknown,
  clientId: unknown,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof espExportControllerGetMergeTags>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEspExportControllerGetMergeTagsQueryOptions(orgId, clientId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
